import MatrixGallery_MatrixGalleryIronSkinComponent from '../components/NativeGalleries/MatrixGallery/viewer/skinComps/MatrixGalleryIronSkin/MatrixGalleryIronSkin.skin';
import MatrixGallery_MatrixGalleryIronSkinController from '../components/NativeGalleries/MatrixGallery/viewer/MatrixGallery.controller';


const MatrixGallery_MatrixGalleryIronSkin = {
  component: MatrixGallery_MatrixGalleryIronSkinComponent,
  controller: MatrixGallery_MatrixGalleryIronSkinController
};


export const components = {
  ['MatrixGallery_MatrixGalleryIronSkin']: MatrixGallery_MatrixGalleryIronSkin
};

